import { render, staticRenderFns } from "./RoutesDetail.vue?vue&type=template&id=77644e6b&scoped=true&"
import script from "./RoutesDetail.vue?vue&type=script&lang=js&"
export * from "./RoutesDetail.vue?vue&type=script&lang=js&"
import style0 from "./RoutesDetail.vue?vue&type=style&index=0&id=77644e6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77644e6b",
  null
  
)

export default component.exports